import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { CsplTable as Table, Link } from "../../../components";
import data from "./data.json";
import { getTwoDecimalPlaces, MANAGE_RKAAS_ROUTES } from "../../../utils";
import { useRequest } from "../../../abstracts";
import { MainComponent } from "./MainComponent";
import { getBalanceSheet } from "../../../services";
// import {} from "../../.."

const columns = [
  {
    label: "Particulars",
    className: "column-planName col-md-8",
    columnName: "name",
  },
  {
    label: "Amount",
    className: "column-status col-md-4",
    columnName: "total",
  },
];

const SecondIter = () => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {data.map((e, i) => {
          return (
            <>
              <Table.Tr>
                <Table.Th className="table-sub-header">{e.name}</Table.Th>
              </Table.Tr>
              {e.assets.map((f, j) => {
                return (
                  <>
                    {!isEmpty(f.assets) ? (
                      <Table.Tr>
                        <Table.Th className="table-sub-header">
                          {f.name}
                        </Table.Th>
                      </Table.Tr>
                    ) : (
                      <Table.Tr>
                        {columns.map((x, y) => {
                          if (x.columnName === "total") {
                            return (
                              <Table.Td
                                className={x.className}
                              >{`$ ${getTwoDecimalPlaces(
                                f[x.columnName]
                              )}`}</Table.Td>
                            );
                          }
                          return (
                            <Table.Td className={x.className}>
                              {f[x.columnName]}
                            </Table.Td>
                          );
                        })}
                      </Table.Tr>
                    )}
                    {f.assets?.map((g, k) => {
                      return (
                        <>
                          {isEmpty(g.assets) ? (
                            <Table.Tr>
                              {columns.map((x, y) => {
                                if (x.columnName === "total") {
                                  return (
                                    <Table.Td
                                      className={x.className}
                                    >{`$ ${getTwoDecimalPlaces(
                                      g[x.columnName]
                                    )}`}</Table.Td>
                                  );
                                }
                                return g.isNavigatable ? (
                                  <Table.Td className={x.className}>
                                    <Link to={MANAGE_RKAAS_ROUTES.LEDGERS}>
                                      {g[x.columnName]}
                                    </Link>
                                  </Table.Td>
                                ) : (
                                  <Table.Td className={`${x.className}`}>
                                    {g[x.columnName]}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          ) : (
                            <Table.Tr>
                              <Table.Th className="table-sub-header">
                                {g.name}
                              </Table.Th>
                            </Table.Tr>
                          )}
                          {g.assets?.map((m, n) => {
                            return (
                              <Table.Tr>
                                {columns.map((x, y) => {
                                  if (x.columnName === "total") {
                                    return (
                                      <Table.Td
                                        className={x.className}
                                      >{`$ ${getTwoDecimalPlaces(
                                        m[x.columnName]
                                      )}`}</Table.Td>
                                    );
                                  }
                                  return (
                                    <Table.Td
                                      className={`${x.className} indendation-element`}
                                    >
                                      {m[x.columnName]}
                                    </Table.Td>
                                  );
                                })}
                              </Table.Tr>
                            );
                          })}
                          {!isEmpty(g.assets) && (
                            <Table.Tr>
                              <Table.Td
                                className={`col-md-8 table-sub-header`}
                              >{`Total ${g.name}`}</Table.Td>
                              <Table.Td
                                className={`col-md-4 table-sub-header`}
                              >{`$ ${getTwoDecimalPlaces(g.total)}`}</Table.Td>
                            </Table.Tr>
                          )}
                        </>
                      );
                    })}
                    {!isEmpty(f.assets) && (
                      <Table.Tr>
                        <Table.Td
                          className={`col-md-8 table-sub-header`}
                        >{`Total ${f.name}`}</Table.Td>
                        <Table.Td
                          className={`col-md-4 table-sub-header`}
                        >{`$ ${getTwoDecimalPlaces(f.total)}`}</Table.Td>
                      </Table.Tr>
                    )}
                  </>
                );
              })}
              <br />
            </>
          );
        })}
      </Table.Tbody>
    </Table>
  );
};

const Rkas = () => {
  const [balanceSheetData, setBalanceSheetData] = useState([]);
  const payload = {
    planId: 0,
    fromDate: "2022-12-08T13:08:04.366Z",
    toDate: "2022-12-08T13:08:04.366Z",
  };
  useEffect(() => {
    getBalanceSheet(payload)
      .then((res) => {
        if (res) {
          setBalanceSheetData(res);
        }
      })
      .catch((err) => err);
  }, []);

  const rawBalanceSheet = balanceSheetData?.reduce((res, data) => {
    if (!res[data.header]) {
      res[data.header] = [];
    }
    res[data.header].push(data);
    return res;
  }, {});
  const balanceSheet =
    !isEmpty(rawBalanceSheet) &&
    Object.values(rawBalanceSheet).reduce((e, i) => {
      return i.reduce((res, data) => {
        if (!res[data.category]) {
          res[data.category] = [];
        }
        res[data.category].push(data);
        return res;
      }, {});
    }, {});

  return (
    <div style={{ marginTop: "1rem" }}>
      <SecondIter />
      {/* {data.map((e, i) => (
        <MainComponent value={e} key={i} />
      ))} */}
    </div>
  );
};

export default Rkas;
